import { z } from "zod";
import { UIElementType } from "../../../AppConstants";
import { AppUtility } from "../../../utils/utility";
import { t } from "i18next";

const getGrossMarginLevelSchema = (existingRanges) => {
    console.log("Inside getGrossMarginLevelSchema ::::");
    return z.object({
        GMLevel: z.union([z.literal(0), z.number().positive()])
            .nullable()
            .refine(value => value === null || value >= 0, {
                message: "If entered, the number must be positive or zero",
            }).describe(
                JSON.stringify({
                    inputType: "number",
                    elementType: UIElementType.TEXTFIELD,
                    inputLabel: t("gmLevelList.gmLevel"),
                    isDisabled: true
                })
            ),
        GrossMarginMinPercent: z.union([z.literal(0), z.number().positive().int()])
            .nullable()
            .refine(value => value === null || value >= 0, {
                message: "If entered, the number must be positive or zero",
            }).describe(
                JSON.stringify({
                    inputType: "number",
                    elementType: UIElementType.TEXTFIELD,
                    inputLabel: t("gmLevelList.startRange"),
                    isRequired: true,
                })
            ),
        GrossMarginMaxPercent: z.union([z.literal(0), z.number().positive()])
            .nullable()
            .refine(value => value === null || value >= 0, {
                message: "If entered, the number must be positive or zero",
            }).describe(
                JSON.stringify({
                    inputType: "number",
                    elementType: UIElementType.TEXTFIELD,
                    inputLabel: t("gmLevelList.endRange"),
                    isRequired: true,
                })
            )
    }).superRefine((data, ctx) => {
        const startRange = data.GrossMarginMinPercent;
        const endRange = data.GrossMarginMaxPercent;

        // Check if both ranges are provided
        if (startRange !== null && endRange !== null) {
            // Check if end range is greater than start range
            if (endRange <= startRange) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: "Start range should be less than the end range.",
                    path: ["GrossMarginMaxPercent"],
                });
            }

            // Check if the range overlaps with existing ranges
            if (AppUtility.isNotValidRange(startRange, endRange, existingRanges)) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: "The entered range overlaps with an existing range",
                    path: ["GrossMarginMinPercent"],
                });
            }
        }
    });
};

const getGrossMarginLevelDefaultValue = (value = null) => {
    return {
        GMLevel: value && value.GMLevel ? value.GMLevel : 0,
        GrossMarginMinPercent: value && value.GrossMarginMinPercent ? value.GrossMarginMinPercent : 0,
        GrossMarginMaxPercent: value && value.GrossMarginMaxPercent ? value.GrossMarginMaxPercent : 0
    };
};

const getGrossMarginLevelAPIPostSchema = (countryCode, businessCode) => {
    return {
        countryCode: countryCode,
        businessCode: businessCode,
        grossMarginLevel: [
            {
                HashId: "",
                GMLevel: 0,
                GrossMarginMinPercent: 0,
                GrossMarginMaxPercent: 0,
                Deleted: false,
                CountryCode: countryCode,
                BusinessCode: businessCode,
            },
        ],
    };
};

const getGrossMarginLevelAuditInfoSchema = () => {
    return {
        auditInfo: [
            {
                Location: "Gross Margin Level",
                LocationKey: "",
                Action: null,
                shortDesc: null,
                currentState: null,
                previousState: null,
            },
        ],
    };
};

export {
    getGrossMarginLevelSchema,
    getGrossMarginLevelDefaultValue,
    getGrossMarginLevelAPIPostSchema,
    getGrossMarginLevelAuditInfoSchema,
};
